import type { PlanForm } from "./form";

/** Maps the flat plan form fields to the plan mutation input (nested invoicedPlanIds). */
export const buildPlanMutationData = (formData: PlanForm) => {
  const { invoicedPlanIdAnnually, invoicedPlanIdQuarterly, ...rest } = formData;
  return {
    ...rest,
    defaultPricingId: formData.defaultPricingId || null,
    isPublic: formData.isPublic || false,
    invoicedPlanIds: {
      annually: invoicedPlanIdAnnually?.trim() || null,
      quarterly: invoicedPlanIdQuarterly?.trim() || null,
    },
  };
};
